export var Types;
(function (Types) {
    Types["UPDATE_IDENTITY"] = "UPDATE_IDENTITY";
    Types["UPDATE_RECIPIENT_ID"] = "UPDATE_RECIPIENT_ID";
    Types["UPDATE_MEMBERS"] = "UPDATE_MEMBERS";
    Types["UPDATE_OTHER_USER_STATUS"] = "UPDATE_OTHER_USER_STATUS";
    Types["TYPING_STARTED"] = "TYPING_STARTED";
    Types["TYPING_ENDED"] = "TYPING_ENDED";
})(Types || (Types = {}));
//# sourceMappingURL=MemberActions.js.map